import type { InsertEntityMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertEntityDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export type InsertEntityTRPCInput = {
  Name: string;
  Description?: string | null;
  ParentId?: string | null;
  Weight: number;
  OwnerUserIds?: string[] | null;
  OwnerGroupIds?: string[] | null;
};

export const useInsertEntity = createMutationHook({
  name: 'insertEntity',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.entity.create.mutationOptions({ onSuccess }),
  mapInput: (variables: InsertEntityTRPCInput) => variables,
  invalidate: (trpc) => [
    trpc.frontend.entity.register.queryKey(),
    trpc.frontend.entity.getById.queryKey(),
  ],
  mapResponse: (trpcData: { Id: string }): InsertEntityMutation => ({
    insertChildEntity: {
      __typename: 'IdOutput',
      Id: trpcData.Id,
    },
  }),
  graphqlDocument: InsertEntityDocument,
  graphqlVariables: (variables: InsertEntityTRPCInput) => ({
    Name: variables.Name,
    Description: variables.Description,
    ParentId: variables.ParentId,
    Weight: variables.Weight,
    owners: variables.OwnerUserIds ?? [],
    ownerGroups: variables.OwnerGroupIds ?? [],
  }),
  evictFields: ['entity', 'entity_by_pk'],
});
